import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getClientFormBuilderHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.clientFormList(action.payload),
		);
		yield put({
			type: types.GET_CLIENTFORMLIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CLIENTFORMLIST_ERROR,
			payload,
		});
	}
}

export function* getClientFormBuilderWatcherSaga() {
	yield takeLatest(
		types.GET_CLIENTFORMLIST_START,
		getClientFormBuilderHandlerSaga,
	);
}

//get/id

//create
